import {
  Form,
  Input,
  InputNumber,
  Button,
  Row,
  Col,
  Typography,
  Radio,
} from "antd";
import moment from "moment";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useHistory, useParams } from "react-router-dom";
import DatePickerPtBr from "../../../components/DatePickerPtBr";
import Spinner from "../../../components/Spinner";
import useUploadFile from "../../../components/UploadFile";
import Api, { Rotas } from "../../../services/api";
import { IOferta } from "../../../types/IOferta";

interface ParamsProps {
  id: string;
}

export default function OfertaNewEdit() {
  const { UploadFile, removeFilesOnApi, addFileToBeRemoved } = useUploadFile();

  const history = useHistory();
  const params = useParams<ParamsProps>();
  const [form] = Form.useForm();
  const ofertaId = params.id;
  const editing = !!ofertaId;
  const { data, isLoading: isLoadingQuery } = useQuery<IOferta[]>(
    Rotas["/oferta/pesquisar/:textSearch"].replace(":textSearch", ofertaId)
  );
  const [loading, setLoading] = useState(false);

  async function onFinish(oferta: IOferta) {
    try {
      setLoading(true);
      if (editing) {
        await Api.put(Rotas["/oferta/:id"].replace(":id", ofertaId), {
          ...oferta,
          dataInicio: moment(oferta.dataInicio).toDate(),
          dataFim: moment(oferta.dataFim).toDate(),
        });
      } else {
        await Api.post(Rotas["/oferta"], {
          ...oferta,
          dataInicio: moment(oferta.dataInicio).toDate(),
          dataFim: moment(oferta.dataFim).toDate(),
        });
      }
      removeFilesOnApi({ clearState: false });
      history.push("/ofertas");
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  const colConfig = {
    xs: 20,
    md: 12,
  };
  const { Title } = Typography;

  if (loading || isLoadingQuery || !data) {
    return <Spinner />;
  }

  function getInitialValues() {
    if ((data?.length ?? 0) > 0 && data)
      return {
        ...data[0],
        dataInicio: moment(data[0].dataInicio),
        dataFim: moment(data[0].dataFim),
      };

    return {};
  }

  return (
    <div>
      <Row gutter={[12, 12]} align="middle" justify="center">
        <Col>
          <Title level={2}>Oferta</Title>
        </Col>
      </Row>
      <Row align="middle" justify="center">
        <Col {...colConfig}>
          <Form
            form={form}
            layout="vertical"
            name="basic"
            initialValues={getInitialValues()}
            onFinish={onFinish}
          >
            <Form.Item
              label="Produto"
              name="nomeProduto"
              rules={[{ required: true, max: 50 }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Unidade de Medida"
              name="unidadeMedida"
              rules={[{ required: true, max: 10 }]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Detalhe" name="detalhe" rules={[{ max: 240 }]}>
              <Input />
            </Form.Item>

            <Form.Item
              label="Notificar com imagem?"
              name="notificarComImagem"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label={`Imagem`}
              name="imagem"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <UploadFile
                onRemove={addFileToBeRemoved}
                initialValue={
                  data && data.length > 0 ? data[0].imagem : undefined
                }
                onSucess={(sucessFile) => {
                  form.setFieldsValue({
                    imagem: sucessFile,
                  });
                }}
              />
            </Form.Item>

            <Form.Item name="tipo" label="Tipo" rules={[{ required: true }]}>
              <Radio.Group>
                <Radio value="Publicidade">Publicidade</Radio>
                <Radio value="Oferta">Oferta</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="Produto disponível na loja física?"
              name="disponivelLoja"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="Produto disponpivel na loja online?"
              name="disponivelOnline"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="URL do produto na loja online"
              name="urlCompraOnline"
              rules={[{ required: false, max: 240 }]}
            >
              <Input />
            </Form.Item>

            <Title level={2}>Valores</Title>
            <Row gutter={[12, 12]}>
              <Col span="12">
                <Form.Item
                  label="Original"
                  name="valorOriginal"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber decimalSeparator="," />
                </Form.Item>
              </Col>
              <Col span="12">
                <Form.Item
                  label="Promocao"
                  name="valorPromocao"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber decimalSeparator="," />
                </Form.Item>
              </Col>
            </Row>

            <Title level={2}>Duração</Title>
            <Row gutter={[12, 12]}>
              <Col span="12">
                <Form.Item
                  label="Início"
                  name="dataInicio"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <DatePickerPtBr />
                </Form.Item>
              </Col>
              <Col span="12">
                <Form.Item
                  label="Fim"
                  name="dataFim"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <DatePickerPtBr />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              wrapperCol={{
                style: {
                  alignItems: "center",
                },
              }}
            >
              <Button type="primary" htmlType="submit">
                Salvar
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
